import React from 'react';
import { FilterBadgeHookParams, AdObjectiveBadgeHookResult } from '../types';

interface AdObjective {
  id: string;
  name: string;
  objective: string;
}

interface UseAdObjectiveBadges extends FilterBadgeHookParams {
  adObjectives: AdObjective[];
  adObjectiveIds?: string[];
}

export const useAdObjectiveBadges = ({
  adObjectives,
  adObjectiveIds = [],
}: UseAdObjectiveBadges): AdObjectiveBadgeHookResult => {
  const adObjectiveBadges = React.useMemo(
    () => adObjectives?.filter((objective) => adObjectiveIds.includes(objective.id)),
    [adObjectives, adObjectiveIds],
  );

  return {
    adObjectiveBadgesProps: {
      data: adObjectiveBadges,
    },
  };
};
